import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-svc-fault",
  "use": "icon-soc-svc-fault-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-svc-fault\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M640 192l192 192-96 96-64-64-224 224-96-96 224-224-64-64z\" /><rect x=\"224\" y=\"640\" width=\"192\" height=\"96\" rx=\"16\" transform=\"rotate(-20 320 688)\" /><path d=\"M288 288h64v64H288zM288 384h64v64H288z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-svc-fault.svg
// module id = a6i+
// module chunks = 488